/* v3-chrome JS voor main-blog: toggle landenbar + sync mobile actionbar hoogte. */
(function(){
  var KEY = 'jb-landenbar-collapsed';
  var tab = document.getElementById('jbNavCollapseTab');
  var label = document.getElementById('jbNavCollapseLabel');
  function apply(collapsed){
    document.body.classList.toggle('jb-landenbar-collapsed', collapsed);
    if (label) label.textContent = collapsed ? 'Reisgidsen wereldwijd' : 'Verberg';
    var arrow = tab && tab.querySelector('svg polyline');
    if (arrow) arrow.setAttribute('points', collapsed ? '9 18 15 12 9 6' : '15 18 9 12 15 6');
    var mabLabel = document.getElementById('jbMabToggleLabel');
    var mabArrow = document.querySelector('#jbMabToggle svg polyline');
    if (mabLabel) mabLabel.textContent = '';
    if (mabArrow) mabArrow.setAttribute('points', collapsed ? '9 18 15 12 9 6' : '15 18 9 12 15 6');
  }
  if (tab) {
    var isDesktop = window.matchMedia('(min-width: 901px)').matches;
    var initial = !isDesktop;
    try {
      var stored = localStorage.getItem(KEY);
      if (stored === '0') initial = false;
      else if (stored === '1') initial = true;
    } catch(e){}
    apply(initial);
    tab.addEventListener('click', function(){
      var next = !document.body.classList.contains('jb-landenbar-collapsed');
      apply(next);
      try { localStorage.setItem(KEY, next ? '1' : '0'); } catch(e){}
    });
  }
  var mabToggle = document.getElementById('jbMabToggle');
  if (mabToggle) {
    mabToggle.addEventListener('click', function(){
      var next = !document.body.classList.contains('jb-landenbar-collapsed');
      apply(next);
      try { localStorage.setItem(KEY, next ? '1' : '0'); } catch(e){}
    });
  }

  // Sync landenbar hoogte naar CSS var
  function syncH(){
    var nav = document.querySelector('.joeba-city-nav');
    if (!nav) return;
    var r = nav.getBoundingClientRect();
    /* Meet de afstand van de onderkant van het scherm tot de bovenkant van de
       landenbar: zo klopt de popup-bodem ook als de bar is ingeklapt of
       gedeeltelijk buiten beeld staat (geen gat meer op mobiel). */
    var h = Math.max(0, Math.round((window.innerHeight || 0) - r.top));
    if (!h) h = Math.round(r.height || 0);
    document.documentElement.style.setProperty('--jb-landenbar-h', h + 'px');
  }
  syncH();
  window.addEventListener('resize', syncH, { passive: true });
  window.jbSyncLandenbarH = syncH;
  window.addEventListener('load', syncH);
  if (window.ResizeObserver) {
    var navEl = document.querySelector('.joeba-city-nav');
    if (navEl) new ResizeObserver(syncH).observe(navEl);
  }

  // Meet header- en landenbar-hoogte en zet --jb-toc-top / --jb-toc-bottom op de TOC
  // (zelfde aanpak als main-article-v3 .jb-toc-rail)
  function measureTocOffsets(){
    var toc = document.getElementById('jbBlogToc');
    if (!toc) return;
    toc.hidden = false;
    var headerH = 0;
    var sel = '#shopify-section-header, .shopify-section-group-header-group, .shopify-section-header-sticky, sticky-header, .header-wrapper, header.section-header, header.shopify-section-header, .header';
    var hs = document.querySelectorAll(sel);
    Array.prototype.forEach.call(hs, function(h){
      var r = h.getBoundingClientRect();
      var vb = Math.max(0, Math.round(r.bottom));
      if (vb > headerH) headerH = vb;
    });
    if (document.body.classList.contains('jb-header-hidden')) headerH = 0;
    var nav = document.querySelector('.joeba-city-nav');
    var bottomH = 0;
    if (nav) {
      var br = nav.getBoundingClientRect();
      if (br.height && br.bottom <= window.innerHeight + 4) bottomH = Math.max(0, Math.round(br.height));
    }
    if (window.innerWidth < 1024) { headerH = 0; bottomH = 0; }
    toc.style.setProperty('--jb-toc-top', headerH + 'px');
    toc.style.setProperty('--jb-toc-bottom', bottomH + 'px');
  }
  // Site-header hoogte als CSS var (gebruikt door fixed continenten-bar in main-blog hero)
  function syncSiteHeaderVar(){
    var headerH = 0;
    var sel = '#shopify-section-header, .shopify-section-group-header-group, .shopify-section-header-sticky, sticky-header, .header-wrapper, header.section-header, header.shopify-section-header, .header';
    var hs = document.querySelectorAll(sel);
    Array.prototype.forEach.call(hs, function(h){
      var r = h.getBoundingClientRect();
      var vb = Math.max(0, Math.round(r.bottom));
      if (vb > headerH) headerH = vb;
    });
    if (document.body.classList.contains('jb-header-hidden')) headerH = 0;
    document.documentElement.style.setProperty('--jb-site-header-h', headerH + 'px');
    // Popup-top: identiek aan main-article-v3 (2px overlap tegen donkere streep)
    document.documentElement.style.setProperty('--jb-popup-top', Math.max(0, headerH - 2) + 'px');
  }
  syncSiteHeaderVar();
  window.addEventListener('resize', syncSiteHeaderVar, { passive: true });
  window.addEventListener('scroll', syncSiteHeaderVar, { passive: true });
  window.addEventListener('load', syncSiteHeaderVar);
  measureTocOffsets();
  window.addEventListener('resize', measureTocOffsets, { passive: true });
  window.addEventListener('scroll', measureTocOffsets, { passive: true });
  window.addEventListener('load', measureTocOffsets);

  // Header sticky hide on scroll down
  var lastY = window.pageYOffset || 0;
  var ticking = false;
  var TH = 8;
  window.addEventListener('scroll', function(){
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function(){
      var y = window.pageYOffset || 0;
      var dy = y - lastY;
      if (y < 80) document.body.classList.remove('jb-header-hidden');
      else if (dy > TH) document.body.classList.add('jb-header-hidden');
      else if (dy < -TH) document.body.classList.remove('jb-header-hidden');
      lastY = y;
      ticking = false;
    });
  }, { passive: true });

  // Geen attention-pulse meer op blognavigatie: alle bouncy/pulse hints uitgeschakeld.
})();

/* Breadcrumb/bestemmingskiezer zit nu in de gedeelde asset
   joeba-destination-nav.js (identiek op blog- en landenpagina's). */
